import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "how-do-doctors-decide-which-depression-treatment-to-recommend",
  title: "How Do Doctors Decide Which Depression Treatment to Recommend?",
  description:
    "Doctors consider many factors when recommending depression treatment — diagnosis, history, medications, symptoms, and patient preferences. Learn how the decision is made.",
  keywords:
    "how doctors decide depression treatment, treatment recommendation, clinical decision depression, personalized treatment",
  badge: "Educational Article",
  heroTitle: "How Do Doctors Decide Which Depression Treatment to Recommend?",
  heroSubtitle:
    "Treatment recommendations aren't arbitrary. They're based on a careful evaluation of your individual situation. Here's what goes into that decision.",
  sections: [
    {
      heading: "Diagnosis and Symptoms",
      body: "Your specific diagnosis and symptom profile are the starting point. Different treatments are appropriate for different conditions and presentations.",
    },
    {
      heading: "Treatment History",
      body: "What you've tried before matters. If you've had adequate trials of certain medications without relief, that information guides which treatments may be worth considering next.",
    },
    {
      heading: "Current Medications",
      body: "Your current medication list is reviewed to understand potential interactions and how a new treatment might fit with your existing regimen.",
    },
    {
      heading: "Health History",
      body: "Certain health conditions, such as seizure history or implanted devices, are relevant to candidacy for some treatments. Your full health history is part of the evaluation.",
    },
    {
      heading: "Patient Preferences and Circumstances",
      body: "Your schedule, treatment goals, and personal circumstances are part of the conversation. The best treatment is one you can realistically commit to.",
      callout: true,
    },
    {
      heading: "It's a Conversation, Not a Formula",
      body: "Treatment recommendations are made collaboratively. Your clinician brings expertise; you bring knowledge of your own life. The decision is made together.",
    },
  ],
  faq: [
    {
      question: "Will my doctor tell me which treatment to choose?",
      answer:
        "Your clinician recommends based on your situation, but the decision is collaborative. They explain the options and their reasoning; you decide what feels right.",
    },
    {
      question: "What if I disagree with the recommendation?",
      answer:
        "You can always ask questions and discuss alternatives. A good clinician welcomes your input and wants you to be comfortable with the plan.",
    },
  ],
  related: [
    {
      title: "What Happens During a Consultation",
      href: "/depression-treatment-consultation",
    },
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
    {
      title: "Compare Depression Treatments",
      href: "/compare-treatments",
    },
  ],
  finalCtaText:
    "Understanding how recommendations are made can ease the process. Speak with our team about your situation.",
});
